"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0; // Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

var toolbar = ['searchreplace bold alignleft aligncenter fontsizeselect fontselect alignright outdent image charmap preview anchor pagebreak insertdatetime media table forecolor backcolor fullscreen'];var _default =

toolbar;exports.default = _default;